import { useEffect } from 'react';
import { LOCAL_WIDGET_ID, Show } from '@elfsight/lib-utils';
import { FormProvider } from '@elfsight/widget-form-builder/widget';
import { useSettings } from '@wu/widget-core';
import type { PaymentFormLayoutProps } from '../../../common';
import { FormPage } from '../form';
import { PaymentPage } from '../payment';
import { useCheckoutNavigation } from '../providers';
import { SuccessMessage } from './success-message';

export function PaymentFormLayout({
  formPageSettings,
  paymentPageSettings,
  successMessageSettings
}: PaymentFormLayoutProps) {
  const { widgetId } = useSettings();
  const { checkoutStep, setCheckoutStep } = useCheckoutNavigation();

  useEffect(() => {
    setCheckoutStep('form');
  }, [formPageSettings, setCheckoutStep]);

  useEffect(() => {
    if (checkoutStep === 'success') {
      setCheckoutStep('payment');
    }
  }, [paymentPageSettings, setCheckoutStep]);

  return (
    <FormProvider widgetId={widgetId || LOCAL_WIDGET_ID}>
      {/* FormPage должен оставаться смонтированным на шаге оплаты, чтобы замыкание
          changedFields в FormContainer оставалось актуальным и захватывало значение
          email, введённое на странице оплаты, до отправки формы после платежа. */}
      <FormPage {...formPageSettings} hidden={checkoutStep !== 'form'} />

      <Show when={checkoutStep === 'payment'}>
        <PaymentPage {...paymentPageSettings} />
      </Show>

      <Show when={checkoutStep === 'success'}>
        <SuccessMessage {...successMessageSettings} />
      </Show>
    </FormProvider>
  );
}
